// composables/useChat.js
import { ref } from 'vue';
import { useChatStore } from '@/stores/chatStore';
import { streamChat } from '@/api/chatApi';

export function useChat() {
    const store = useChatStore();
    const loading = ref(false);
    const controller = ref(null);

    async function sendMessage(userInput) {
        if (!userInput.trim() || loading.value) return;

        store.addUserMessage(userInput);

        const assistantMsg = store.startAssistantMessage();  // 保留引用

        loading.value = true;
        controller.value = new AbortController();

        try {
            for await (const chunk of streamChat(
                store.messages.map(m => ({ role: m.role, content:[{ value: m.content, type: 'input' }]})),
                controller.value.signal
            )) {
                store.appendToLastMessage(chunk);
                // 或者直接：assistantMsg.content += chunk;
            }
        } catch (err) {
            if (err.name !== 'AbortError') {
                assistantMsg.content += '\n\n[生成出错，请重试]';  // 使用了变量
                console.error(err);
            }
        } finally {
            assistantMsg.isStreaming = false;  // 明确使用变量结束 streaming
            loading.value = false;
            controller.value = null;
        }
    }

    function stopStreaming() {
        if (controller.value) {
            controller.value.abort();
        }
    }

    return {
        messages: store.messages,
        loading,
        sendMessage,
        stopStreaming,
    };
}